import { motion, useReducedMotion } from "framer-motion";
import {
    defaultTransition,
    fadeIn,
    fadeUp,
    scaleIn,
    slideInLeft,
    slideInRight,
    viewport,
} from "@/lib/motionVariants";

const VARIANTS = {
    fadeUp,
    fadeIn,
    scaleIn,
    slideInLeft,
    slideInRight,
};

export default function ScrollReveal({
    children,
    className,
    delay = 0,
    variant = "fadeUp",
}) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={VARIANTS[variant] || fadeUp}
            transition={{ ...defaultTransition, delay }}
        >
            {children}
        </motion.div>
    );
}
